import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function HouseIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M27.25 1H17.25C15.1825 1 13.5 2.68243 13.5 4.74984V9.12341C13.7737 9.26966 14.0387 9.43715 14.2912 9.63464L18.5 12.9295V12.2508H21V14.8857L21.1012 14.9644C22.6262 16.1569 23.5 17.9518 23.5 19.8867V22.2504H26V24.7503H23.5V31H28C29.6569 31 31 29.6569 31 28V4.74984C31 2.68243 29.3175 1 27.25 1ZM21 9.74964H18.5V7.24974H21V9.74964ZM26 19.7492H23.5V17.2493H26V19.7492ZM26 14.7494H23.5V12.2495H26V14.7494ZM26 9.74964H23.5V7.24974H26V9.74964ZM19.5612 16.9331L12.7512 11.6021C11.7212 10.7958 10.28 10.7946 9.25 11.6021L2.43875 16.9318C1.525 17.6481 1 18.7255 1 19.8855V27.9987C1 29.6556 2.34315 30.9988 4 30.9988H21V19.8855C21 18.7243 20.475 17.6481 19.5612 16.9331ZM13.5 24.749H8.5V19.7492H13.5V24.749Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
